import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import api  from '../../services/api';


export const useTagStore = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      
      const res = await api.post("/tags/store", body);
      return res;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['viewtags']);
    },
  });

};
